import { Injectable } from '@angular/core';
import { HttpService } from '@app/@core/services/http.service';
import { API_ENDPOINTS } from '@app/shared/constants/apiconstants';
import { Observable } from 'rxjs';

export interface NotificationPayload {
  priority: string;
  message: string;
  actionurl: string;
  userid: string | number;
  customformid: number;
  isnew: boolean;
  isactive: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class CommonNotificationService {

  constructor(private httpService: HttpService) {}

  /**
   * Sends a notification to the specified user
   * @param payload The notification payload
   * @returns Observable of the HTTP response
   */
  sendNotification(payload: NotificationPayload): Observable<any> {
    return this.httpService.post(API_ENDPOINTS.notifiction, payload);
  }

  /**
   * Creates notification payload for any transaction type
   * @param message The full notification message
   * @param educatorUserId The educator's pics_core user id (notification API `userid`)
   * @returns Notification payload
   */
  createNotificationPayload(message: string, educatorUserId: string | number): NotificationPayload {
    return {
      priority: 'High',
      message: message,
      actionurl: 'example action',
      userid: educatorUserId,
      customformid: 1,
      isnew: true,
      isactive: true
    };
  }
}